import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import './Certificates.css';

const Certificates = ({ studentId, studentType }) => {
  const [certificates, setCertificates] = useState([]);
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [moduleLoading, setModuleLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentCertificate, setCurrentCertificate] = useState({
    Id: null,
    ModuleName: '',
    ModuleId: '',
    Link: '',
    Date: new Date().toISOString().split('T')[0],
    Img: null,
    ImgFile: null,
    LinkFile: null,
    FirstName: '',
    LastName: ''
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [certificateToDelete, setCertificateToDelete] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('userData');
        const headers = { 'Authorization': `Bearer ${token}` };

        // Fetch modules based on studentType
        const modulesResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teacher/Curriculum/modules/${studentType}`,
          { headers }
        );
        setModules(modulesResponse.data);

        // Fetch certificates
        const certsResponse = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/mystudents/student-certificates/${studentId}`,
          { headers }
        );
        setCertificates(certsResponse.data.certificates || []);
        
        setError(null);
      } catch (err) {
        setError(err.response?.data?.error || err.message);
        setCertificates([]);
      } finally {
        setLoading(false);
        setModuleLoading(false);
      }
    };

    fetchData();
  }, [studentId, studentType]);

 
  




 
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = parseISO(dateString);
      return format(date, 'MMM dd, yyyy');
    } catch {
      return '';
    }
  };

  return (
    <div className="sp-certificates-container">
      <div className="sp-certificates-header">
        <h3>Student Certificates</h3>
        <button 
          className="sp-btn sp-btn-primary"
        >
          <i className="fas fa-plus"></i> Add Certificate
        </button>
      </div>

      {error && <div className="sp-alert sp-alert-danger">{error}</div>}

      {loading ? (
        <div className="sp-loading">Loading certificates...</div>
      ) : (
        <>
          {certificates.length === 0 ? (
            <div className="sp-no-certificates">
              No certificates found for this student.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="sp-certificates-table">
                <thead>
                  <tr>
                    <th>Module Name</th>
                    <th>Issue Date</th>
                    <th>Certificate PDF</th>
                    <th>Certificate Image</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {certificates.map(cert => (
                    <tr key={`${cert.ModuleName}-${cert.Date}`}>
                      <td>{cert.ModuleName}</td>
                      <td>{formatDate(cert.Date)}</td>
                      <td>
                        {cert.Link ? (
                          <a 
                            href={`${process.env.REACT_APP_API_BASE_URL1}/assets/Certificates/${cert.Link}`} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="sp-certificate-link"
                          >
                            View PDF
                          </a>
                        ) : (
                          'No file attached'
                        )}
                      </td>
                      <td>
                        {cert.Img ? (
                          <a 
                            href={`${process.env.REACT_APP_API_BASE_URL1}/assets/img/certificates/${cert.Img}`} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="sp-certificate-link"
                          >
                            View Image
                          </a>
                        ) : (
                          'No file attached'
                        )}
                      </td>
                      <td>
                        <button 
                          className="sp-btn sp-btn-sm sp-btn-outline"
                        >
                          <i className="fas fa-edit"></i> Edit
                        </button>
                        <button 
                          className="sp-btn sp-btn-sm sp-btn-outline-danger"
                        >
                          <i className="fas fa-trash"></i> Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

    
     
    </div>
  );
};

export default Certificates;